import { FC } from 'react';

import { Formik, FormikHelpers } from 'formik';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

import { SpecialDropFormValues, specialDropValidationSchema } from '../form';

import { RewardsFormControl } from 'v2/components/form/rewardsFormControl/RewardsFormControl';
import { REWARD_STUB, UserRewardType } from 'v2/constants';
import { SpecialDropType } from 'v2/types/SpecialDropModel';

// Для SPIN_BANNER дропов эти типы наград недоступны (поведение перенесено из старой формы).
const SPIN_BANNER_EXCLUDED_REWARD_TYPES = [UserRewardType.SPECIAL_TICKET, UserRewardType.YANDEX_STATION];

interface SpecialDropFormProps {
  initialValues: SpecialDropFormValues;
  submitButtonCaption?: string;
  isSubmitting?: boolean;
  onSubmit: (values: SpecialDropFormValues, helpers: FormikHelpers<SpecialDropFormValues>) => void | Promise<void>;
}

export const SpecialDropForm: FC<SpecialDropFormProps> = ({
  initialValues,
  submitButtonCaption = 'Save',
  isSubmitting = false,
  onSubmit,
}) => (
  <Formik
    initialValues={initialValues}
    onSubmit={onSubmit}
    validationSchema={specialDropValidationSchema}
    enableReinitialize
    validateOnBlur
    validateOnChange={false}
  >
    {(formik) => {
      const { values, handleChange, handleBlur, errors, touched, handleSubmit, dirty } = formik;
      const isChanceToWinError = touched.chanceToWin && !!errors.chanceToWin;

      const excludedRewardTypes =
        values.type === SpecialDropType.SPIN_BANNER ? SPIN_BANNER_EXCLUDED_REWARD_TYPES : undefined;

      return (
        <form className="form" onSubmit={handleSubmit}>
          <TextField
            label="Chance To Win"
            id="chanceToWin"
            name="chanceToWin"
            type="number"
            value={values.chanceToWin}
            onBlur={handleBlur}
            onChange={handleChange}
            error={isChanceToWinError}
            helperText={isChanceToWinError ? errors.chanceToWin : undefined}
            fullWidth
            required
          />

          <RewardsFormControl
            formik={formik}
            initialValue={{ ...REWARD_STUB }}
            required
            withCount
            excludedTypes={excludedRewardTypes}
          />

          <Button type="submit" variant="contained" loading={isSubmitting} disabled={isSubmitting || !dirty}>
            {submitButtonCaption}
          </Button>
        </form>
      );
    }}
  </Formik>
);
